import { createPortal } from "react-dom";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { FullscreenModal, Button, CalendarInput, DropFileInput } from "shared";
import "./CloseInvestmentPolicyModal.scss";

interface CloseInvestmentPolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
  item: any | null;
}

interface FormValues {
  closedAt: string;
  file: File | null;
}

const validationSchema = Yup.object({
  closedAt: Yup.string().required("Data zamknięcia jest wymagana"),
  file: Yup.mixed().nullable(),
});

const initialValues: FormValues = {
  closedAt: "",
  file: null,
};

const CloseInvestmentPolicyModal = ({
  isOpen,
  onClose,
  item,
}: CloseInvestmentPolicyModalProps) => {
  const handleSubmit = (values: FormValues) => {
    console.log("Zamknij polisę inwestycyjną:", {
      investmentUuid: item?.uuid,
      closedAt: values.closedAt,
      file: values.file,
    });
    onClose();
  };

  if (!item) return null;

  return createPortal(
    <FullscreenModal isOpen={isOpen} onClose={onClose}>
      <div className="close-investment-policy-modal">
        <h2 className="fullscreen-modal__header">
          Zamknij Polisy inwestycyjne / IKE
        </h2>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {(formik) => (
            <Form className="close-investment-policy-modal__form">
              <div className="close-investment-policy-modal__fields">
                <div className="close-investment-policy-modal__field">
                  <Field
                    type="date"
                    name="closedAt"
                    label="Data zamknięcia"
                    component={CalendarInput}
                    errors={formik.errors}
                  />
                </div>
                <div className="close-investment-policy-modal__field">
                  <Field
                    label="Umowa"
                    name="file"
                    id="file"
                    as={DropFileInput}
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    optional
                  />
                </div>
              </div>
              <div className="close-investment-policy-modal__actions">
                <Button
                  type="button"
                  onClick={onClose}
                  label="Anuluj"
                  className="button--stroke button--rounded"
                />
                <Button
                  type="submit"
                  onClick={() => {}}
                  label="Potwierdź"
                  className="button--rounded button--black"
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </FullscreenModal>,
    document.body,
  );
};

export default CloseInvestmentPolicyModal;
